﻿import axios from "axios";
import { refreshToken } from "./auth/authSlice";
import { queueForRetry, popRetryQueue } from "./auth/retryRequestSlice";
import { store } from "../store";

// set default baseURL
const instance = axios.create({
  responseType: "json",
  baseURL: "https://" + window.location.host + "/api", //dynamic url for (dev, qa and prod)
});

instance.interceptors.request.use(async (req) => {
  const token = localStorage.getItem("accessToken");
  req.headers.Authorization = token ? `Bearer ${token}` : "";
  req.headers["Content-Type"] =
    req.headers["Content-Type"] ?? "application/json"; // All requests should be json
  return req;
});

// create a response interceptor to check for 401s
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response) {
      const status = error.response.status;
      const originalRequest = error.config;
      if (
        status === 401 &&
        !originalRequest._retry &&
        !originalRequest.url.startsWith("/login")
      ) {
        if (store.getState().tempInfo.retryRequest.isRefreshing) {
          return new Promise((resolve, reject) => {
            store.dispatch(queueForRetry({ resolve, reject }));
          }).then(() => instance(originalRequest));
        }

        originalRequest._retry = true;

        let error = null;
        try {
          await store.dispatch(refreshToken());
        } catch (err) {
          error = err;
        }
        let refreshQueue = store.dispatch(popRetryQueue());

        if (error) {
          refreshQueue.forEach(({ _, reject }) => reject(error));
          return Promise.reject(error);
        }

        refreshQueue.forEach(({ resolve }) => resolve());
        return instance(originalRequest);
      }
      return Promise.reject(error); //failed 401 (expired session) and other errors continue on
    }
  }
);

export default instance;
